import { useMemo, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDebounce } from '../../../../utils/hooks';
import {
  IUsersTableQuery,
  IUsersTableQueryVariables,
  UserState,
} from '../../../../utils/apollo/graphqlSchema';
import { GET_USERS_TABLE } from '../../../../utils/apollo/permission';

const useUsers = (userStates: UserState[]) => {
  const [roles, setRoles] = useState<string[]>([]);
  const [states, setStates] = useState<UserState[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchQuery = useDebounce(searchTerm, 300);

  const { data, refetch, loading } = useQuery<
    IUsersTableQuery,
    IUsersTableQueryVariables
  >(GET_USERS_TABLE, {
    variables: {
      pagination: {
        first: 0,
        after: 0,
      },
      term: debouncedSearchQuery,
      includes: [],
      userStates,
    },
  });

  const entities = data?.users?.entities;
  const users = useMemo(() => {
    if (!entities?.length) {
      return [];
    }

    if (!roles.length && !states.length) {
      return entities;
    }

    return entities.filter((user) => {
      let roleIncludes = true;
      let stateIncludes = true;

      if (roles.length > 0) {
        roleIncludes = user.roles.some((role) => roles.includes(role.name));
      }
      if (states.length > 0) {
        stateIncludes = states.includes(user.state);
      }

      return roleIncludes && stateIncludes;
    });
  }, [entities, roles, states]);

  const total = users.length;

  return {
    refetch,
    loading,
    users,
    total,
    searchTerm,
    setSearchTerm,
    roles,
    setRoles,
    states,
    setStates,
  };
};

export default useUsers;
